import { AssignmentDetail } from '../../../../../js/api';
import { formatApiDate } from '../../../utils/date';

type Props = {
  assignmentsUpdated: AssignmentDetail[];
};

export function AssignmentsUpdated({ assignmentsUpdated }: Props) {
  if (assignmentsUpdated.length === 0) {
    return null;
  }

  if (assignmentsUpdated.length > 1) {
    const handleClick = () => {
      window.location.href = '/app/provider/assignments';
    };
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
        className="tw:bg-warning-section-bg tw:rounded-xl tw:p-4 tw:border tw:border-orange-300/20  tw:hover:bg-orange-300/20 tw:transition-colors tw:cursor-pointer"
      >
        <div className="tw:flex tw:items-start tw:gap-3">
          <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-warning-section-text tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <i className="fa-solid fa-fw fa-clipboard-list tw:text-white tw:text-base tw:sm:text-lg" />
          </div>
          <div className="tw:flex-col">
            <div className="tw:font-medium tw:text-warning-section-text tw:hover:underline">
              {assignmentsUpdated.length} Updated Assignments
            </div>
            <div className="tw:text-sm">Click to view and respond</div>
          </div>
        </div>
      </div>
    );
  }

  const assignment = assignmentsUpdated[0];
  const facilityName = assignment.facility?.name;
  const reasonTitle = assignment.current_reason?.title;

  const handleClick = () => {
    window.location.href = `/app/provider/assignments/${assignment.id}`;
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      className="tw:bg-warning-section-bg tw:rounded-xl tw:p-4 tw:border tw:border-orange-300/20 tw:hover:bg-orange-300/20 tw:transition-colors tw:cursor-pointer"
    >
      <div className="tw:flex tw:items-start tw:gap-3">
        <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-warning-section-text tw:rounded-full tw:flex tw:items-center tw:justify-center">
          <i className="fa-solid fa-fw fa-calendar-lines-pen tw:text-white tw:text-base tw:sm:text-lg" />
        </div>
        <div className="tw:flex-col">
          <div className="tw:font-medium tw:text-warning-section-text tw:hover:underline">
            Click to View Updated Assignment
          </div>
          <div className="tw:text-sm tw:text-zinc-700">
            {facilityName} assignment starting {formatApiDate(assignment.start_on)} has{' '}
            {reasonTitle}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssignmentsUpdated;
